// specific to SA
import Component from '../../UM-Base/components/Component';
import { getConfig, getAccessTokenOrSignin, UserManager } from '../../UM-Base/lib/OidcHelper';
import { getTripPlannerUrl, receiveMessageListener, isSandboxMode, getApiServerUrl } from '../../UM-Base/lib/TripPlannerHelper';
import { componentValues, initAddToTripCardBtnListeners, initModal, signOut, closeModal, getProduct, runAnalyticsAction } from '../lib/AddToTripCardBtnHelper';


// a global function on window object. Could be called by SearchSubmit.js after new search results added to DOM.
// initAddToTripCardBtnListeners function available globally for Optimizely extensions.
window.satc.initAddToTripCardBtnListeners = initAddToTripCardBtnListeners;


let thisComponent = null;  // setup for a less painful way to pass js class "this" around.


export default class AddToTripModal extends Component {  // export default

  load() {
    thisComponent = this;  // store "this" on class load.

    window.usersTrips = [];

    componentValues.apiHubUrl = getApiServerUrl();

    super.load();

    // console.info('AddToTripModal component');

    initAddToTripCardBtnListeners(); // run during initial page load for existing cards.

    $('.tripmodal__save-bottom').on('click', this.onClickSave.bind(this));
    $('#signout-link').on('click', signOut.bind(this));

    const config = getConfig(window.location);
    componentValues.oidcUserManager = new UserManager(config);
    this.setDigitalData(componentValues.oidcUserManager);

    // listener - when modal is closed forget that it was open
    $('#addToTripModal').on('hidden.bs.modal', function (evt) {
      sessionStorage.removeItem('modalOpen_Add');
      sessionStorage.removeItem('modalOpen_Plan');
      sessionStorage.removeItem('lastLogin');
    });

    // if AddToTrip modal was left open then re-open
    const signinPageVisited = sessionStorage.getItem('signinPageVisited');
    const modalLeftOpen = sessionStorage.getItem('modalOpen_Add');

    if (!!signinPageVisited && !!modalLeftOpen) {
      initModal();
      $('#addToTripModal').modal('show');
    }

    // We listen to changes on localstorage (the listener will only be fired if
    // another Browser-Tab makes changes)
    window.addEventListener('storage', (evt) => {
      if (evt.key === 'LOGGED_IN') {
        sessionStorage.removeItem('oidc.user:https://id-test.southaustralia.com/:tripPlannerM');
        sessionStorage.removeItem('oidc.user:https://id.southaustralia.com/:tripPlannerM');
      }
    });

    // Listen for a response from the iframe
    window.addEventListener("message", (event) => receiveMessageListener(event), false);
  }

  async setDigitalData(anOidcUserManager) {
    const user = await anOidcUserManager.getUser();

    // Add hashed email to the datalayer
    if (user && user.profile) {
      if (typeof window.digitalData.visitor === 'undefined') {
        window.digitalData.visitor = {};
      }
      
      const hashEmail = await this.hash(user.profile.email);
      window.digitalData.visitor.visitorHash = hashEmail
      localStorage.setItem("digitalData.visitor.visitorHash", hashEmail);      

      window.digitalData.account = window.digitalData.account || {};
      window.digitalData.account.ID = window.digitalData.account.ID || '';
      window.digitalData.account.ID = user.profile.sid;
    }
  }


  async onClickSave() {
    // Show Saving
    $('.tripmodal__saving-message').css('display', 'block');
    // $('.tripmodal__save-bottom').text('Saving');

    // Remove Cancel and Save
    $('.tripmodal__close-bottom').css('display', 'none');
    $('.tripmodal__save-bottom').css('display', 'none');

    // Small Delay to display message before closing modal
    const delayInMilliseconds = 1000; //1 second

    setTimeout(() => {  // arrow functions use Lexical 'this' rules
      closeModal();
    }, delayInMilliseconds);

    // Get product detail object
    const product = getProduct();

    if (isSandboxMode()) {
      if (product !== null) {
        thisComponent.addToTripSanboxMode(product.Id)
      } else {
        console.error('ERROR: product is null');
      }

      return;
    }

    // Perform Save
    this.setItineraries(componentValues.itineraryQueue, product);
    runAnalyticsAction("trip_action", "save trip", componentValues.itineraryQueue, product);

    componentValues.itineraryQueue = [];
    sessionStorage.removeItem('modalOpen_Add');
    sessionStorage.removeItem('modalOpen_Plan');
  }


  async setItineraries(saveQueue, product) {
    let dayItineraryId = '';
    let dayId = '';
    const token = await getAccessTokenOrSignin(componentValues.oidcUserManager);
    if (!token) return;

    // Get Message stored e.g. search:itineraryId:dayId
    const dayItinId = sessionStorage.getItem('defaultDay');
    if (dayItinId) {
      const dayItinArr = dayItinId.split(':');
      dayItineraryId = dayItinArr[1];
      dayId = dayItinArr[2];
    }

    // Convert Save queue to object and add dayId from query string
    const saveQueueObj = [];
    saveQueue.forEach(id => {
      const tripObj = { itineraryId: id };
      if (dayItineraryId === id && dayId) {
        tripObj.dayId = dayId;
      }
      saveQueueObj.push(tripObj);
    });

    // send data to itineraries
    const itineraryAdd = {
      "itineraryIds": saveQueueObj,
      "productId": product.Id
    };

    const myHeaders = new Headers({
      'accept': '*/*',
      'Authorization': token,
      'Content-Type': 'application/json'
    });

    fetch(`${componentValues.apiHubUrl}/api/Itinerary/AddProductToLatest`, {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(itineraryAdd)
    }).then(res => {
      // console.log("Request response:", res);
      // console.log("res status:", res.status);
      if (res && res.status !== 200) {
        console.error("Request not 200. Response:", res);
      }
    }).catch(error => {
      console.error('POST failed: ', error);
      if (error.status === 401) {
        console.error("Unauthorized. Need to reset session: ", error.status);
        //TODO: signOut();  // logoutLocal and close modal
      }
    });
  }


  hash(string) {
    const utf8 = new TextEncoder().encode(string);
    return crypto.subtle.digest('SHA-256', utf8).then((hashBuffer) => {
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map((bytes) => bytes.toString(16).padStart(2, '0'))
        .join('');
      return hashHex;
    });
  }


  // getProductId(e) {
  //   // If event used then its from search results
  //   if(!e) {
  //     const target = $(evt.target);
  // 	  return target.attr('productid');
  //   }

  //   // otherwise its from a product page
  //   const product = getProduct()
  //   return product.id;
  // }


  addToTripSanboxMode(productId) {
    //Set modal URL for sending message to iframe
    const iframe = document.getElementById('trip-frame');

    if (iframe && iframe.contentWindow) {
      const iframeUrl = getTripPlannerUrl();
      const message = { code: 'add_product_to_trip', payload: { productId: productId } }
      iframe.contentWindow.postMessage(message, iframeUrl);
    }
  }

};
